import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import { enterpriseTokens } from "styles/theme";

const EngineeringPanelHeader = ({ eyebrow, title, subtitle }) => (
    <Box sx={{ px: 1.5, py: 1.25, borderBottom: `1px solid ${enterpriseTokens.lineSoft}`, backgroundColor: "#FBFCFE" }}>
        <Chip
            label={eyebrow}
            size="small"
            sx={{ mb: 0.5, height: 19, borderRadius: "999px", bgcolor: enterpriseTokens.primarySoft, color: enterpriseTokens.primaryDark, fontWeight: 600, fontSize: "9px", textTransform: "uppercase" }}
        />
        <Typography sx={{ fontSize: "12px", lineHeight: "20px", fontWeight: 600, color: enterpriseTokens.navy }}>
            {title}
        </Typography>
        <Typography sx={{ mt: 0.25, fontSize: "11px", lineHeight: "16px", fontWeight: 500, color: enterpriseTokens.muted }}>
            {subtitle}
        </Typography>
    </Box>
);

export default EngineeringPanelHeader;
